/**
 * All tab grouping policy, shared by the Items and SOR mounts.
 *
 * The query stamps `Pending` onto rows unioned in from `claimCodes` (`stage.item.metadata.ts`) and
 * leaves the primary `codes` array alone, so absence is the authorised bucket. The natural
 * discriminator, `isClaimCode`, is `hidden` and therefore denied by the projection, so it never
 * reaches a row and cannot be read here.
 *
 * Value and order live together so the labels the board groups by and the labels it ranks can never
 * drift apart.
 */

/** Group key of both All views (`job.item.system.views.ts`). Virtual — the query stamps its value. */
export const AUTHORISATION_COLUMN_ID = 'workOrders.codes.authorisation';

const AUTHORISED = 'Authorised';
/** Must match the stamp in `stage.item.metadata.ts` — the api spec pins that string, this one pins it here. */
const PENDING = 'Pending';

/** Ticket order: authorised first, pending second. */
const GROUP_ORDER = [AUTHORISED, PENDING];

/** Group label for one item row. Anything the query did not stamp is authorised. */
export function resolveAuthorisationGroup(item: { authorisation?: string } | null | undefined): string {

  return item?.authorisation === PENDING ? PENDING : AUTHORISED;
}

/** Reads the `authorisation` stamp: `isClaimCode` is hidden in the metadata, so no row carries it. */
export function isPendingItemRow(item: { authorisation?: string } | null | undefined): boolean {

  return resolveAuthorisationGroup(item) === PENDING;
}

/**
 * Rank for AG's `initialGroupOrderComparator`. An unknown key scores 0, so a grouping the user picked
 * instead (Location, say) compares equal on both sides and keeps the order the rows arrived in.
 */
export function authorisationGroupRank(key: unknown): number {

  const rank = GROUP_ORDER.indexOf(key as string);
  return rank === -1 ? 0 : rank;
}
